import { render, staticRenderFns } from "./DownloadPDFLoading.vue?vue&type=template&id=4722723d&scoped=true&"
import script from "./DownloadPDFLoading.vue?vue&type=script&lang=js&"
export * from "./DownloadPDFLoading.vue?vue&type=script&lang=js&"
import style0 from "./DownloadPDFLoading.vue?vue&type=style&index=0&id=4722723d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4722723d",
  null
  
)

export default component.exports